"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordSchema = exports.record = void 0;
const parser_1 = require("./parser");
const result_1 = require("./result");
const record = (key, value) => new RecordSchema(key, value);
exports.record = record;
class RecordSchema {
    constructor(key, value) {
        this.name = null;
        this.key = key;
        this.value = value;
    }
    setTypeName(name) {
        this.name = name;
        return this;
    }
    parse(value, options) {
        return this.debug(value, options).mapError(parser_1.toMessage);
    }
    debug(value, options) {
        if (typeof value !== 'object' || Array.isArray(value) || !value) {
            return (0, result_1.failure)(parser_1.BasicParsingError.from({
                expectedType: this.name || "record",
                receivedValue: value,
                parserName: "record",
            }));
        }
        const keys = Object.keys(value);
        // Theory, I think its less expensive to check all the keys before starting to check their values.
        for (const key of keys) {
            const result = this.key.debug(key);
            if (!result.success) {
                // Maybe a wrapped error with a nicer message to.
                return (0, result_1.failure)(new parser_1.RecordParsingError({
                    expectedType: this.name || "record",
                    receivedValue: value,
                    parserName: "record",
                    key: key,
                    innerError: result.error,
                }));
            }
        }
        for (const key of keys) {
            const result = this.value.debug(value[key]);
            if (!result.success) {
                // Maybe a wrapped error with a nicer message to.
                return (0, result_1.failure)(new parser_1.RecordParsingError({
                    expectedType: this.name || "record",
                    receivedValue: value,
                    parserName: "record",
                    key: key,
                    innerError: result.error,
                }));
            }
        }
        return (0, result_1.success)(value);
    }
}
exports.RecordSchema = RecordSchema;
